import { createContext, Fragment, useState, lazy, Suspense } from "react";
import Accesorios from "../configura/pages/Accesorios/Accesorios.js";
import Home from "../configura/pages/Home/Home";
import Resumen from "../configura/pages/Resumen/Resumen";
import { Helmet } from "react-helmet";
import Versiones from "../configura/pages/Versiones/Versiones";
import Menu from "../menu/Menu";
import NavSub from "../configura/components/NavSub/NavSub";
const Footer = lazy(() => import('../footer/Footer'));
export const DataContext = createContext();
function ConfiguraHyundai(props) {
    const [step, setStep] = useState(1);
    let [accesoriosIndividuales, setAccesoriosIndividuales] = useState([]);
    let [kits, setKits] = useState([]);
    let [modeloSeleccionado, setModeloSeleccionado] = useState({
        detalleVersion: {
            VEA_PRECIO_PVP: 0
        }
    });
    return (
        <Fragment>
            <Helmet>
                <meta
                    name="description"
                    content="Ahora puedes personalizar tu propio Hyundai y añadirle accesorios a tu gusto, pruebalo ahora."
                />
                <meta name="keywords" content="Hyundai configura, personaliza, construye, versiones" />
                <title>Configura tu Hyundai</title>
            </Helmet>
            <Menu />
            <DataContext.Provider
                value={{
                    step,
                    setStep,
                    accesoriosIndividuales,
                    setAccesoriosIndividuales,
                    kits,
                    setKits,
                    modeloSeleccionado,
                    setModeloSeleccionado
                }
                }
            >
                <div>
                    {step === 1 &&
                        <>
                            <NavSub
                                numeroPaso={false}
                                btnRigth={false}
                                subtitle="¿Qué modelo va contigo?"
                                btnLeft={false}
                            />
                            <Home>
                            </Home>
                        </>
                    }
                    {step === 2 &&
                        <>
                            <NavSub
                                btnRigth={true}
                                numeroPaso={step - 1}
                                subtitle={`Elige la versión y color de tu ${modeloSeleccionado?.MOD_NOMBRE}`}
                                btnLeft={true}
                            />
                            <Versiones>
                            </Versiones>
                        </>
                    }
                    {step === 3 &&
                        <>
                            <NavSub
                                btnRigth={true}
                                numeroPaso={step - 1}
                                subtitle={`Configura tu ${modeloSeleccionado?.versionSeleccionada?.VER_NOMBRE}`}
                                btnLeft={true}
                            />
                            <Accesorios>
                            </Accesorios>
                        </>
                    }
                    {step === 4 &&
                        <>
                            <NavSub
                                btnRigth={false}
                                numeroPaso={step - 1}
                                subtitle="Resúmen de tu configuración"
                                btnLeft={true}
                            />
                            <Resumen>
                            </Resumen>
                        </>
                    }
                </div>
            </DataContext.Provider>
            <Suspense fallback={<div>Cargando footer...</div>}>
                <Footer />
            </Suspense>
        </Fragment>
    );
}
export default ConfiguraHyundai;